

















import {Component, Prop, Vue} from 'vue-property-decorator';
import ZCLogo from '../assets/logo.svg';
import InnerBadge from '@/components/InnerBadge.vue';
// @ is an alias to /src

@Component({
	components: {
		ZCLogo,
		'inner-badge': InnerBadge
	}
})
export default class Badge extends Vue {
	@Prop({default: null})
	badgeId!: string | null;

	@Prop({default: null})
	ticketId!: string | null;

	showOverlay = false;
	closeReason = '';

	close(reason: string = '') {
		this.closeReason = reason;
		this.showOverlay = false;
	}

	finalClose() {
		this.$emit('close', this.closeReason);
	}

}
